/* Engraving preview: on mobile/tablet, shrink a line only if its text would run past the grey plate. Revert: empty this file. */
(function () {
  function fit() {
    var area = document.getElementById('engraving-preview-area');
    if (!area) return;
    var mobile = window.matchMedia('(max-width: 989px)').matches;
    var limit = area.clientWidth * 0.8;
    ['preview-line-1', 'preview-line-2', 'preview-line-3'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.style.removeProperty('font-size');
      if (!mobile || !el.textContent) return;
      var r = document.createRange();
      r.selectNodeContents(el);
      var w = r.getBoundingClientRect().width;
      if (w > limit) {
        var base = parseFloat(getComputedStyle(el).fontSize);
        el.style.setProperty('font-size', (base * limit / w).toFixed(2) + 'px', 'important');
      }
    });
  }
  function init() {
    var area = document.getElementById('engraving-preview-area');
    if (!area) return;
    var mo = new MutationObserver(fit);
    ['preview-line-1', 'preview-line-2', 'preview-line-3'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
    if (window.ResizeObserver) new ResizeObserver(fit).observe(area);
    window.addEventListener('resize', fit);
    fit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
